// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1Gqyx","title":"AfterBackImages_title__tF6nB","images":"AfterBackImages_images__1_QPf"};